import './styles/box.css';

import { FC } from 'react';
import { BoxProps } from './types';

export const Box: FC<BoxProps> = ({ text, image, width }) => {
    return (
        <div className='mainBox'>
            <img style={{ width: width ? width : 'unset', height: width ? 'auto' : 72 }} src={image} />
            <p>{text}</p>
        </div>
    );
};
